<template>
    <div>
        <SphereNavigation color="yellow" selected="appointment-list-completed" />

        <div class="inner-content">
            <div class="top-actions">
                <DatePicker v-model:date="date" :lockPast="false" color="yellow"/>

                <SearchField v-model:search="searchText" />
            </div>

            <div class="inner-content--list">
                <div class="list">
                    <div v-for="appointment in appointmentList" :key="appointment.id" class="list--item yellow" >
                        <div class="list--item--btns">
                            <AppointmentItemSales :appointment="appointment" />

                            {{formatAppointmentTime(appointment)}}

                            <ClientNames :appointment="appointment" />
                        </div>

                        <div class="list--item--btns">
                            <button class="btn-round black btn-result" v-if="appointment.measurement_done" @click.prevent="viewResult(appointment)">
                                <img src="/img/icon-view.svg" />
                            </button>
                        </div>
                    </div>
                    <div v-if="appointmentList.length == 0 && !loading" class="list--empty">
                        {{$t('appointment_completed.empty')}}
                    </div>
                </div>
            </div>
        </div>

        <Loading v-if="loading" />
    </div>
</template>

<script>
import AppointmentItemSales from "@/components/AppointmentItemSales.vue";
import ClientNames from "@/components/ClientNames.vue";
import DatePicker from "@/components/DatePicker.vue";
import Loading from "@/components/app/Loading.vue";
import SphereNavigation from "@/components/app/SphereNavigation.vue";
import SearchField from "@/components/app/SearchField.vue";
import AppointmentListMixin from "@/mixins/AppointmentListMixin";
import {newDateFromString, getDateForPicker} from "@/utils/utils";
import {apiStore} from "@/stores/api";
import {measurementStore} from "@/stores/measurement";

export default {
    name : "AppointmentListCompleted",
    components : {
        AppointmentItemSales,
        ClientNames,
        SearchField,
        DatePicker,
        Loading,
        SphereNavigation
    },
    mixins: [
        AppointmentListMixin
    ],

    data() {
        return {
            searchText : ""
        };
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            const fromRoutes = ["appointment-result", "client-detail"];
            if (from !== undefined && fromRoutes.includes(from.name) && measurementStore().measurementDate !== undefined) {
                vm.date = measurementStore().measurementDate;
            } else {
                vm.date = getDateForPicker(new Date());
            }
        });
    },

    computed: {
        appointmentList() {
            const list = this.appointments.filter(x => x.measurement_done || (x.clients.length > 0 && x.clients[0].measurement_result !== null));
            return list.sort((d1, d2) => newDateFromString(d1.date) > newDateFromString(d2.date) ? -1 : 1);
        }
    },

    watch: {
        searchText() {
            if (this.searchText.trim() !== "") {
                this.appointments = apiStore().searchAppointments(this.searchText);

            } else {
                this.getAppointmentsForDate();
            }
        },

        date() {
            measurementStore().measurementDate = this.date;
        }
    },

    methods: {
        viewResult(appointment) {
            this.$router.push({name : "appointment-result", params : {appointment_id:appointment.id}});
        }
    }
};
</script>

<style lang="scss" scoped>
    .inner-content {
        &--cols {
            display:flex;
        }

        .top-actions {
            display:flex;
            align-items: center;
            justify-content: space-between;
            height: 3.7rem;
            width: 85%;
            margin-left: 15%;
        }

        &--list {
            width: 85%;
            margin-left: 15%;

            .list {
                max-height: 55vh;

            }
        }

    }
</style>